module.exports = __webpack_public_path__ + "static/img/hezuo-step-info.833072ee.png";